import { render, staticRenderFns } from "./poolDetail.vue?vue&type=template&id=b38e33b0&scoped=true"
import script from "./poolDetail.vue?vue&type=script&lang=js"
export * from "./poolDetail.vue?vue&type=script&lang=js"
import style0 from "./poolDetail.vue?vue&type=style&index=0&id=b38e33b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e33b0",
  null
  
)

export default component.exports